import styled from 'styled-components'
import { color, ColorProps } from 'styled-system'

export const Button = styled.button<ColorProps>`
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  text-transform: capitalize;
  font-weight: bold;
  font-size: 14px;
  line-height: 13px;
  text-align: center;
  letter-spacing: 0.217732px;
  color: black;
  background: #fcd83a;
  border-radius: 2px;
  padding: 16px 40px;
  height: 50px;
  align-self: flex-end;
  margin-top: 25px;
  ${color}
`

export const Container = styled.div<ColorProps>`
  align-self: center;
  padding: 20px 40px;
  background-color: #222b43;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 1;
  position: relative;
  ${color};
  @media screen and (max-width: 450px) {
    padding: 10px 40px;
  }
`

type TextColor = {
  error?: string
  textColor?: string
}

export const Input = styled.input<TextColor>`
  color: ${({ textColor }) => textColor || '#7A7E92'};
  border: 1px solid ${({ error, textColor }) => (error ? '#f2392c' : textColor || '#7A7E92')};
  border-radius: 6px;
  background-color: white;
  font-size: 14px;
  line-height: 17px;
  letter-spacing: 0.217732px;
  padding: 16px;
  display: flex;
  width: calc(100% - 34px);
  &::placeholder {
    color: ${({ textColor }) => textColor || '#7A7E92'};
  }
  @media screen and (max-width: 450px) {
    padding: 8px 16px;
  }
`

export const InputContainer = styled.div`
  margin-bottom: 8px;
  width: 100%;
  align-self: center;
`

export const InputError = styled.p`
  margin: 0;
  margin-top: 4px;
  color: #f2392c;
  font-size: 12px;
`

export const Title = styled.h2`
  text-transform: capitalize;
  font-style: normal;
  font-weight: normal;
  align-self: flex-start;
  font-size: 16px;
  line-height: 28px;
  color: inherit;
  margin-bottom: 20px;
  @media screen and (max-width: 450px) {
    margin-bottom: 10px;
  }
`
